import React from 'react';
import { Tab, Tabs, TabsProps } from '@mui/material';

import { TP_COLORS } from '../../constants';
import { getThemeMode } from '../../store/ConfigSlice';
import { useAppSelector } from '../../hooks';

export interface ITabItem {
  index: number;
  key: string;
  title: string;
}

interface TabBarProps {
  selectedTab?: ITabItem;
  tabs: ITabItem[];
  tabProps?: TabsProps;
  onChange: (
    event: React.SyntheticEvent<Element, Event>,
    value: number
  ) => void;
}

const a11yProps = (index: number) => {
  return {
    id: `tabItem-${index}`,
    'aria-controls': `tabPanel-${index}`,
  };
};

const TabBar: React.FC<TabBarProps> = ({
  selectedTab,
  tabs = [],
  tabProps = {
    TabIndicatorProps: { hidden: true },
  },
  onChange = undefined,
}) => {
  // Store
  const themeMode = useAppSelector(getThemeMode);

  const tabContainerStyles: React.CSSProperties = {
    backgroundColor: TP_COLORS.paperGray.light,
    padding: '4px',
    borderRadius: '7px',
  };

  if (themeMode === 'dark') {
    tabContainerStyles.backgroundColor = TP_COLORS.paperGray.dark;
  }

  return (
    <Tabs
      value={selectedTab?.index || 0}
      onChange={onChange}
      sx={tabContainerStyles}
      {...tabProps}
    >
      {tabs.map((tab, index) => {
        const isSelected = tab.index === selectedTab?.index || 0;

        const tabStyles: React.CSSProperties = {
          color: TP_COLORS.black,
          borderRadius: '7px',
          fontWeight: 600,
        };

        if (themeMode === 'dark' && !isSelected) {
          tabStyles.color = TP_COLORS.white;
        }

        if (isSelected) {
          tabStyles.backgroundColor = TP_COLORS.white;
        }

        return (
          <Tab
            key={tab.key}
            color="inherit"
            label={tab.title}
            style={tabStyles}
            {...a11yProps(index)}
          />
        );
      })}
    </Tabs>
  );
};

export default TabBar;
